<template>
    <div>
        <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">notifications
            </h2>
            <p class="text-secondary">Key updates to keep you informed</p>
        </div>
        <card>
          <span v-if="notifications.length > 0">
            <div v-for="notification in notifications" :key="notification.id" class="row notification-wrap align-items-center pb-3 mb-3 border-bottom flex-nowrap">
                <!-- <div class="col-auto">
                    <span >
                        <img width="60" height="60" class="img-fluid" src="img/theme/avatar.svg" alt="">
                    </span>
                </div> -->
                <div class="col-auto">
                    <h5 class="font-weight-normal

                    ">{{ notification.notification.message }}</h5>
                    <span class="text-h6">{{ getTimeAgo(notification.created_at) }}</span>
                </div>
                <div class="col-auto d-flex flex-grow-1 justify-content-end">
                    <div class="el-outer-link">
                        <el-dropdown trigger="click" class="wrap" @visible-change="handleDropdown">
                            <span class="el-dropdown-link d-inline-block" :class="{'active': isDropdownActive}">
                            <svg width="32" class="trigger-icon" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="16" r="16" fill="#EDEDED" />
                                <path
                                    d="M16.5 9.67188C17.0954 9.67188 17.5781 9.18918 17.5781 8.59375C17.5781 7.99832 17.0954 7.51562 16.5 7.51562C15.9046 7.51562 15.4219 7.99832 15.4219 8.59375C15.4219 9.18918 15.9046 9.67188 16.5 9.67188Z"
                                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M16.5 17.5781C17.0954 17.5781 17.5781 17.0954 17.5781 16.5C17.5781 15.9046 17.0954 15.4219 16.5 15.4219C15.9046 15.4219 15.4219 15.9046 15.4219 16.5C15.4219 17.0954 15.9046 17.5781 16.5 17.5781Z"
                                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M16.5 25.4844C17.0954 25.4844 17.5781 25.0017 17.5781 24.4062C17.5781 23.8108 17.0954 23.3281 16.5 23.3281C15.9046 23.3281 15.4219 23.8108 15.4219 24.4062C15.4219 25.0017 15.9046 25.4844 16.5 25.4844Z"
                                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                            <el-dropdown-menu slot="dropdown" class="py-0 px-0">
                                <el-dropdown-item class="py-1 px-3" >
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.117 5.75203C3.31536 5.73886 3.51084 5.80498 3.66047 5.93586C3.8101 6.06675 3.90165 6.25168 3.915 6.45003L4.375 13.35C4.465 14.697 4.529 15.635 4.669 16.34C4.806 17.025 4.996 17.387 5.269 17.643C5.543 17.899 5.917 18.065 6.609 18.155C7.323 18.248 8.263 18.25 9.613 18.25H10.387C11.737 18.25 12.677 18.248 13.391 18.155C14.083 18.065 14.457 17.899 14.731 17.643C15.004 17.387 15.194 17.025 15.331 16.341C15.471 15.635 15.535 14.697 15.625 13.349L16.085 6.45003C16.0916 6.35174 16.1174 6.2557 16.1611 6.1674C16.2048 6.0791 16.2654 6.00027 16.3396 5.93541C16.4137 5.87055 16.4999 5.82092 16.5933 5.78937C16.6866 5.75782 16.7852 5.74497 16.8835 5.75153C16.9818 5.7581 17.0778 5.78396 17.1661 5.82764C17.2544 5.87133 17.3333 5.93197 17.3981 6.00612C17.463 6.08027 17.5126 6.16646 17.5442 6.25979C17.5757 6.35311 17.5886 6.45174 17.582 6.55003L17.118 13.502C17.033 14.784 16.964 15.821 16.802 16.634C16.633 17.479 16.347 18.185 15.755 18.738C15.163 19.291 14.44 19.531 13.585 19.642C12.763 19.75 11.725 19.75 10.44 19.75H9.56C8.275 19.75 7.237 19.75 6.415 19.642C5.56 19.531 4.836 19.292 4.245 18.738C3.653 18.185 3.367 17.478 3.198 16.634C3.036 15.82 2.968 14.784 2.882 13.502L2.418 6.55003C2.41148 6.45173 2.42439 6.35312 2.456 6.25981C2.4876 6.1665 2.53728 6.08033 2.60219 6.00623C2.6671 5.93212 2.74597 5.87153 2.83431 5.82792C2.92264 5.7843 3.0187 5.75852 3.117 5.75203ZM8.355 0.250033H8.309C8.093 0.250033 7.904 0.250033 7.726 0.278033C7.37929 0.333576 7.05039 0.469494 6.76561 0.674914C6.48084 0.880334 6.24809 1.14955 6.086 1.46103C6.002 1.62103 5.943 1.80003 5.875 2.00503L5.86 2.04903L5.763 2.33903L5.734 2.42503C5.64346 2.67636 5.47479 2.89206 5.25272 3.04053C5.03064 3.189 4.76685 3.26242 4.5 3.25003H1.5C1.30109 3.25003 1.11032 3.32905 0.96967 3.4697C0.829018 3.61035 0.75 3.80112 0.75 4.00003C0.75 4.19895 0.829018 4.38971 0.96967 4.53036C1.11032 4.67101 1.30109 4.75003 1.5 4.75003H18.501C18.6999 4.75003 18.8907 4.67101 19.0313 4.53036C19.172 4.38971 19.251 4.19895 19.251 4.00003C19.251 3.80112 19.172 3.61035 19.0313 3.4697C18.8907 3.32905 18.6999 3.25003 18.501 3.25003H15.41C15.1429 3.24363 14.8849 3.1518 14.6738 2.98803C14.4627 2.82426 14.3096 2.59716 14.237 2.34003L14.14 2.04903L14.126 2.00503C14.057 1.80003 13.998 1.62103 13.915 1.46103C13.7528 1.14943 13.5199 0.880135 13.2349 0.674708C12.95 0.469281 12.6209 0.33343 12.274 0.278033C12.0806 0.254515 11.8858 0.245156 11.691 0.250033H8.355ZM7.145 2.93503C7.105 3.04437 7.05933 3.14937 7.008 3.25003H12.992C12.9407 3.14804 12.8953 3.0432 12.856 2.93603L12.816 2.82203L12.717 2.52203C12.6807 2.3966 12.6363 2.27367 12.584 2.15403C12.53 2.05004 12.4524 1.96014 12.3574 1.89155C12.2624 1.82295 12.1527 1.77757 12.037 1.75903C11.9067 1.74749 11.7757 1.74448 11.645 1.75003H8.355C8.067 1.75003 8.007 1.75203 7.963 1.76003C7.8474 1.77846 7.73772 1.8237 7.64274 1.89211C7.54775 1.96053 7.4701 2.05023 7.416 2.15403C7.396 2.19403 7.374 2.24903 7.283 2.52303L7.183 2.82303L7.145 2.93503Z"
                                            fill="#696969" />
                                    </svg>
                                    <span class="ml-2" @click="deleteUserNotification(notification.notification.id)">Delete</span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
          </span>

            <div class="grid-wrap border rounded p-3" v-else>
              <img :src="emptySlotIcon" alt="No data available" class="w-100"
                style="max-width: 300px; margin: 0 auto; display: block;">
            </div>


            <!-- <div class="pagination-wrap mt-4 mb-3 d-flex justify-content-end">
                                <nav>
                                    <ul class="pagination custom-pagination">
                                        <li class="page-item">
                                            <a class="page-link" href="#">
                                                <span>
                                                    <svg width="7" height="15" viewBox="0 0 7 15" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M6.68912 0.384851C6.78767 0.506051 6.86585 0.650013 6.9192 0.808497C6.97254 0.966982 7 1.13688 7 1.30845C7 1.48003 6.97254 1.64993 6.9192 1.80841C6.86585 1.96689 6.78767 2.11086 6.68912 2.23206L2.56453 7.31515L6.68912 12.3982C6.88788 12.6432 6.99955 12.9754 6.99955 13.3218C6.99955 13.6683 6.88788 14.0005 6.68912 14.2455C6.49036 14.4904 6.22077 14.628 5.93968 14.628C5.65858 14.628 5.389 14.4904 5.19023 14.2455L0.310879 8.2322C0.212332 8.111 0.134148 7.96704 0.0808029 7.80856C0.0274577 7.65007 4.76837e-07 7.48018 4.76837e-07 7.3086C4.76837e-07 7.13702 0.0274577 6.96713 0.0808029 6.80864C0.134148 6.65016 0.212332 6.5062 0.310879 6.385L5.19023 0.37175C5.59419 -0.126079 6.27453 -0.126079 6.68912 0.384851Z"
                                                            fill="#A9A9A9" fill-opacity="0.73" />
                                                    </svg>

                                                </span>
                                            </a>
                                        </li>
                                        <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                        <li class="page-item"><a class="page-link" href="#">4</a></li>
                                        <li class="page-item"><a class="page-link" href="#">5</a></li>
                                        <li class="page-item">
                                            <a class="page-link" href="#" aria-label="Next">
                                                <span><svg width="7" height="15" viewBox="0 0 7 15" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M0.31088 0.384851C0.212332 0.506051 0.134148 0.650013 0.0808034 0.808497C0.0274585 0.966982 0 1.13688 0 1.30845C0 1.48003 0.0274585 1.64993 0.0808034 1.80841C0.134148 1.96689 0.212332 2.11086 0.31088 2.23206L4.43547 7.31515L0.31088 12.3982C0.112115 12.6432 0.000450125 12.9754 0.000450125 13.3218C0.000450125 13.6683 0.112115 14.0005 0.31088 14.2455C0.509645 14.4904 0.779227 14.628 1.06032 14.628C1.34142 14.628 1.611 14.4904 1.80977 14.2455L6.68912 8.2322C6.78767 8.111 6.86585 7.96704 6.9192 7.80856C6.97254 7.65007 7 7.48018 7 7.3086C7 7.13702 6.97254 6.96713 6.9192 6.80864C6.86585 6.65016 6.78767 6.5062 6.68912 6.385L1.80977 0.37175C1.40581 -0.126079 0.725466 -0.126079 0.31088 0.384851Z"
                                                            fill="#A9A9A9" fill-opacity="0.73" />
                                                    </svg>
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
            </div> -->


        </card>




    </div>
</template>
<style scoped>
.trigger-icon circle {
    fill: #fff;
}
.el-dropdown-link .trigger-icon:hover circle , .el-dropdown-link.active .trigger-icon circle {
    fill: #EDEDED;
}
.el-dropdown-link {
    cursor: pointer;
    /* color: #409EFF; */
}

.el-dropdown-menu {
    min-width: 155px;
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #fff;
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover span{
    color: #4E4E4E;
}

.demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
}

.notification-wrap h5 {
    margin: 0;
    font-size: 18px;
    line-height: 20px;
    color: #4E4E4E;
}
@media screen and (max-width: 575px) {
    .notification-wrap h5 {
    font-size: 16px;
    }
    .notification-wrap img {
        width: 50px;
        height: 50px;
    }
}
.notification-wrap span {
    margin: 0;
    font-size: 14px;
    color: #4E4E4E;
}
</style>
<script>
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import Vue from "vue";
import Sortable from "sortablejs";
import { Table, TableColumn, Select, Option } from "element-ui";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
export default {
  computed: {
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
    },
    emptySlotIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/safedig_empty_slot.svg')
        : 'img/theme/empty_slot.png';
    },
  },
    data() {
    return {
      notifications : [],
      totalNotifications : 0,
      unreadNotifications : 0,
      username:"",
      user_id:"",
    };
  },
  created() {
    if (localStorage.getItem("hot-user") === "employee") {
      this.username = "employee";
      this.user_id = localStorage.getItem("hot-user-id");
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.username = "Admin";
    }else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.username = "Sub Admin";
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.username = "company";
      this.user_id = localStorage.getItem("hot-admin-id");
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.username = "manager";
      this.user_id = localStorage.getItem("hot-user-id");
    }
    this.getNotifications();
    this.markNotificationAsRead();
  },
    components: {
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    methods: {
      getTimeAgo(createdAt) {
      const now = new Date();
      const createdTime = new Date(createdAt);
      const diffInMs = now - createdTime;
      const diffInMinutes = Math.floor(diffInMs / 60000);

      if (diffInMinutes < 60) {
        return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`;
      }

      const diffInHours = Math.floor(diffInMinutes / 60);
      if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`;
      }

      const diffInDays = Math.floor(diffInHours / 24);
      if (diffInDays < 7) {
        return `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`;
      }

      const diffInWeeks = Math.floor(diffInDays / 7);
      if (diffInWeeks < 4) {
        return `${diffInWeeks} week${diffInWeeks === 1 ? '' : 's'} ago`;
      }

      const diffInMonths = Math.floor(diffInDays / 30);
      if (diffInMonths < 2) {
        return `${diffInMonths} month${diffInMonths === 1 ? '' : 's'} ago`;
      }

      return 'more than one month ago';
    },
      getNotifications(all = true) {
        this.$http.get(`notification/user/${this.user_id}`, { params: { all } }).then((res) => {
          this.notifications = res.data;

          this.totalNotifications = res.data.length;
          this.unreadNotifications = res.data.filter(notification => notification.is_read === 0).length;
        });
      },
      markNotificationAsRead() {
          this.$http.post(`notification/mark-read`,{
          user_id : this.user_id,
          }).then((res)=>{
            this.getNotifications();
          });
        },

    deleteUserNotification(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to delete this notification?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.post(`notification/delete/user-notification`, {
            user_id: this.user_id,
            notification_id: id
          }).then((res) => {
            Swal.fire({
              icon: "success",
              title: "Notification Deleted Successfully",
              // showConfirmButton: true,
              // timer: 1500,
              confirmButtonClass: "btn btn-success",

            });
            this.getNotifications();
          });
        }
      });
    },
    handleDropdown(visible) {
      //this.isDropdownActive = visible;
    },
  },
}
</script>
